export default __webpack_public_path__ + "static/media/DOM-AUG2026.bdd0dea3.png";